// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"239":"blog","443":"about","631":"contact"}[chunkId] + "." + {"239":"1b1fc41e","443":"f64ed433","631":"04b97c23"}[chunkId] + ".css";
};